import type { FC } from "react";
import type { PartnerData } from "src/http/api-types";
import { useContent } from "src/shared/components/content";
import { ImageSize } from "src/website-apps/shared/components/image";
import {
  StyledLink,
  StyledTeamCard,
  StyledTeamContentWrapper,
  StyledTeamImage,
  StyledTeamName,
  StyledTicketsMessage,
} from "./styled-components";
import { TeamLogo } from "./TeamLogo";

interface Props {
  className?: string;
  id?: number;
  onClick?: (() => void) | undefined;
  partnerData?: Maybe<PartnerData>;
  text?: Maybe<string>;
  url?: Maybe<string>;
  smallImageUrl?: Maybe<string>;
}

/**
 * Team Card to be Displayed in the Various Team UI Treatments on Category Grouping Pages for Major Leagues
 */
export const TeamCard: FC<Props> = ({ className, id, onClick, partnerData, text, url, smallImageUrl }) => {
  const content = useContent("cid$#3177387#"); // See Tickets
  return (
    <StyledLink onClick={onClick} url={url ?? "#"}>
      <StyledTeamCard className={className}>
        {/* smallImageUrl used for nfl teams exp 23530/1 */}
        {smallImageUrl ? (
          <StyledTeamImage alt="" size={ImageSize.CategoryGroupingLeagueTeamImage} src={smallImageUrl} />
        ) : (
          <TeamLogo id={id} partnerData={partnerData} text={text} />
        )}
        <StyledTeamContentWrapper>
          <StyledTeamName>{text}</StyledTeamName>
          <StyledTicketsMessage>{content}</StyledTicketsMessage>
        </StyledTeamContentWrapper>
      </StyledTeamCard>
    </StyledLink>
  );
};
